import {
  EMPLOYEE_SERVICE_API_GET_EMPLOYEE,
  EMPLOYEE_SERVICE_API_UPDATE_EMPLOYEE,
  EMPLOYEE_SERVICE_API_GET_EMPLOYEES_BY_STATION_WORKGROUP_WITH_DECLARATIONS,
  EMPLOYEE_SERVICE_API_GET_EMPLOYEE_DECLARATION_EVENT_BY_EID_AND_DECLARATION_YEAR,
  EMPLOYEE_SERVICE_API_UPDATE_EMPLOYEE_DECLARATION,
  SYSTEM_API_COMMON_CONFIG,
  DECLARATION_CONFIG,
  GET_LATEST_DECLARATION_BALANCE_IMPORT_STATUS,
  GET_ALLOTMENT_VALUE_BY_STATION_WORKGROUP_AND_YEAR,
} from "../util/constants";
import { getAccessTokenFromCookie } from "../util/authentication";

export const fetchEmployee = async (eid, scope = "") => {
  let apiEndpoint = process.env.REACT_APP_EMPLOYEE_SERVICE_API + EMPLOYEE_SERVICE_API_GET_EMPLOYEE + "/" + eid;
  if (scope) {
    apiEndpoint = apiEndpoint + "?scope=" + scope;
  }
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  return response;
};

export const updateEmployee = async (payload) => {
  const apiEndpoint = process.env.REACT_APP_EMPLOYEE_SERVICE_API + EMPLOYEE_SERVICE_API_UPDATE_EMPLOYEE;
  try {
    const response = await fetch(apiEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      throw Error(`POST ${apiEndpoint} API Call failed.`, response);
    }
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const fetchEmployeesByStationWorkgroupWithDeclarations = async (station, workgroup, declarationYear) => {
  const apiEndpoint =
    process.env.REACT_APP_EMPLOYEE_SERVICE_API +
    EMPLOYEE_SERVICE_API_GET_EMPLOYEES_BY_STATION_WORKGROUP_WITH_DECLARATIONS +
    "/" +
    station +
    "/" +
    workgroup +
    "/" +
    declarationYear;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  return response;
};

export const fetchEmployeeDeclarationEventByEidAndDeclarationYear = async (eid, declarationYear) => {
  const apiEndpoint =
    process.env.REACT_APP_EMPLOYEE_SERVICE_API +
    EMPLOYEE_SERVICE_API_GET_EMPLOYEE_DECLARATION_EVENT_BY_EID_AND_DECLARATION_YEAR +
    "/" +
    eid +
    "/" +
    declarationYear;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  return response;
};

export const addEmpDeclarationEvent = async (declarationEventPayload) => {
  const apiEndpoint = process.env.REACT_APP_EMPLOYEE_SERVICE_API + EMPLOYEE_SERVICE_API_UPDATE_EMPLOYEE_DECLARATION;
  try {
    const response = await fetch(apiEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
      body: JSON.stringify(declarationEventPayload),
    });
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const fetchDeclarationWindowDates = async () => {
  try {
    const apiEndpoint = process.env.REACT_APP_SYSTEM_SERVICE_API + SYSTEM_API_COMMON_CONFIG + "/" + DECLARATION_CONFIG;
    const response = await fetch(apiEndpoint, {
      method: "GET",
      headers: {
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
    });
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const fetchDeclarationBalanceImportStatus = async (station, workgroup, declarationYear) => {
  const apiEndpoint =
    process.env.REACT_APP_EMPLOYEE_SERVICE_API +
    GET_LATEST_DECLARATION_BALANCE_IMPORT_STATUS +
    "/" +
    station +
    "/" +
    workgroup +
    "/" +
    declarationYear;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  return response;
};

export const fetchAllotmentValueByStationWorkgroupAndYear = async (station, workgroup, declarationYear) => {
  const apiEndpoint =
    process.env.REACT_APP_EMPLOYEE_SERVICE_API +
    GET_ALLOTMENT_VALUE_BY_STATION_WORKGROUP_AND_YEAR +
    "/" +
    station +
    "/" +
    workgroup +
    "/" +
    declarationYear;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  return response;
};
